export const MenuItems = [
    {
        title : "Home",
        url : "/",
        cName : "nav-links",
        icon : "fa-solid fa-house"
    },
    
    {
        title : "About Us",
        url : "/about",
        cName : "nav-links",
        icon : "fa-solid fa-circle-info"
    },
    {
        title : "Branches",
        url : "/service",
        cName : "nav-links",
        icon : "fa-solid fa-briefcase"
    },
    {
        title : "Gallery",
        url : "/gallery",
        cName : "nav-links",
        icon: "fa-solid fa-image"
    },
    {
        title : "Contact",
        url : "/contact",
        cName : "nav-links",
        icon : "fa-solid fa-address-book"
    },
    {
        title : "Sign Up",
        url : "/signup",
        cName : "nav-links-mobile"
    },
]
    